import React from 'react';
import styles from './Status.module.scss';
import {IProduct} from 'data/interfaces/products';
import {statusToText} from 'gui/components/listPage/components/ad/components/adStatus';
import {IOrder} from 'data/interfaces/orders';
import Section from '../../../desktopAdStructure/components/sections/components/section';

export interface ISectionProps {
  product?: IProduct;
  order?: IOrder;
  statusToText?: any;
  loading?: boolean;
}

const Status = ({loading, ...props}: ISectionProps) => {
  return (
    <Section width={250} className={`${styles.Status} ${loading ? styles.loading : ''}`.trim()} loading={loading}>
      {props.statusToText(props.product.status || props.order.status)}
    </Section>
  );
};

Status.defaultProps = {
  product: {},
  order: {},
  statusToText: statusToText,
  loading: false,

};
export default Status;
